import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NgxMaskModule } from 'ngx-mask';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';

import { LunaCommonModule } from '../common/common.module';
import { ApplicationsHomeComponent } from './components/applications-home/applications-home.component';
import { StratigraphicHomeComponent } from './components/stratigraphic/stratigraphic-home/stratigraphic-home.component';
import { StratigraphicApplicationComponent } from './components/stratigraphic/stratigraphic-application/stratigraphic-application.component';
import { ApplicationsResolver } from "./resolvers/applications.resolver";
import { PaymentsComponent } from './components/payments/payments.component';
import { PaymentDisplayComponent } from './components/payments/payment-display/payment-display.component';
import { InvoiceComponent } from './components/payments/invoice/invoice.component';
import { StratigraphicApplicationReviewComponent } from './components/stratigraphic/stratigraphic-application-review/stratigraphic-application-review.component';
import { OrganizationInformationComponent } from './components/stratigraphic/sections/organization-information/organization-information.component';
import { PermitTypeComponent } from './components/stratigraphic/sections/permit-type/permit-type.component';
import { WellInformationComponent } from './components/stratigraphic/sections/well-information/well-information.component';
import { WaterSourceComponent } from './components/stratigraphic/sections/water-source/water-source.component';
import { ContactsComponent } from './components/stratigraphic/sections/contacts/contacts.component';
import { WellSiteAccessComponent } from './components/stratigraphic/sections/well-site-access/well-site-access.component';
import { ConstructionComponent } from './components/stratigraphic/sections/construction/construction.component';
import { DocumentationComponent } from './components/stratigraphic/sections/documentation/documentation.component';
import { SignatureComponent } from './components/stratigraphic/sections/signature/signature.component';
import { PaymentComponent } from './components/stratigraphic/sections/payment/payment.component';
import { StratigraphicReviewComponent } from './components/stratigraphic/sections/review/stratigraphic-review.component';
import { ApplicationNotesComponent } from './components/application-notes/application-notes.component';
import { ApplicationTimelineComponent } from './components/application-timeline/application-timeline.component';
import { ViewNotesButtonComponent } from './components/view-notes-button/view-notes-button.component';
import { ApplicationSectionBaseComponent } from './components/application-section-base/application-section-base.component';
import { StratigraphicReadOnlyComponent } from './components/stratigraphic/stratigraphic-read-only/stratigraphic-read-only.component';


@NgModule({
    declarations: [
        ApplicationsHomeComponent,
        StratigraphicHomeComponent,
        StratigraphicApplicationComponent,
        PaymentsComponent,
        PaymentDisplayComponent,
        InvoiceComponent,
        StratigraphicApplicationReviewComponent,
        OrganizationInformationComponent,
        PermitTypeComponent,
        WellInformationComponent,
        WaterSourceComponent,
        ContactsComponent,
        WellSiteAccessComponent,
        ConstructionComponent,
        DocumentationComponent,
        SignatureComponent,
        PaymentComponent,
        StratigraphicReviewComponent,
        ApplicationNotesComponent,
        ApplicationTimelineComponent,
        ViewNotesButtonComponent,
        ApplicationSectionBaseComponent,
        StratigraphicReadOnlyComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        RouterModule,
        LunaCommonModule,
        NgxMaskModule,
        NgSelectModule
    ],
    providers: [
        ApplicationsResolver
    ],
    exports: [
        ApplicationNotesComponent,
        ApplicationTimelineComponent,
        ViewNotesButtonComponent,
        InvoiceComponent
    ]
})
export class ApplicationsModule { }
